<script lang="ts">
  import { onMount } from 'svelte';
  import { navigate } from '../helpers/Navigation';

  onMount(() => {
    navigate(sessionStorage.length >= 4 ? '/search' : '/auth', { replace: true });
  });
</script>
